import { postBiz, json, rows } from '../core/coreapi';
import { IBaselineCoverageRow, IForecastBaselineBatch, IForecastVariableRow } from './forecastBaseline.models';

const SERVICE = 'bieforecastbaseline';

export const normalizeCoverageRow = (r: any): IBaselineCoverageRow => ({
  variablecode: r.variablecode ?? r.vrc ?? r.code ?? '',
  variablename: r.variablename ?? r.vrn ?? r.name ?? '',
  datasetcode: r.datasetcode ?? r.dsc ?? '',
  required: Boolean(r.required ?? r.req ?? true),
  forecastable: Boolean(r.forecastable ?? r.fca ?? true),
  source: r.source ?? r.src ?? 'FACT',
  continuousfrom: r.continuousfrom ?? r.cfr ?? '',
  continuousto: r.continuousto ?? r.cto ?? '',
  forecaststart: r.forecaststart ?? r.fst ?? '',
  readiness: Number(r.readiness ?? r.rdn ?? 0),
  status: r.status ?? r.sts ?? 'WARNING',
  missingperiods: r.missingperiods ?? r.msp ?? [],
  periods: (r.periods ?? r.prd ?? []).map((p: any) => ({
    periodcode: p.periodcode ?? p.pdc ?? '',
    periodname: p.periodname ?? p.pdn ?? p.periodcode ?? p.pdc ?? '',
    startdate: p.startdate ?? p.sdt,
    enddate: p.enddate ?? p.edt,
    status: p.status ?? p.sts ?? 'MISSING',
    approved: Boolean(p.approved ?? p.apv ?? false),
    factcount: Number(p.factcount ?? p.fct ?? 0),
    amount: Number(p.amount ?? p.amt ?? 0),
    remarks: p.remarks ?? p.rmk ?? '',
  })),
});

export const normalizeVariableRow = (r: any): IForecastVariableRow => ({
  id: r.id ?? r.rid ?? r.recid ?? r.variablecode ?? r.vrc,
  rid: r.rid ?? r.recid ?? null,
  variablecode: r.variablecode ?? r.vrc ?? r.shortcode ?? r.shc ?? '',
  variablename: r.variablename ?? r.vrn ?? r.recname ?? r.nam ?? '',
  datasetcode: r.datasetcode ?? r.dsc ?? '',
  forecastmethod: r.forecastmethod ?? r.fmd ?? 'MANAGEMENT_ESTIMATE',
  source: r.source ?? r.src ?? 'FACT',
  required: Boolean(r.required ?? r.req ?? true),
  forecastable: Boolean(r.forecastable ?? r.fca ?? true),
  effectivefrom: r.effectivefrom ?? r.efr ?? '',
  effectiveto: r.effectiveto ?? r.eto ?? '',
  status: r.status ?? r.sts ?? 'ACTIVE',
});

export const normalizeBatch = (r: any): IForecastBaselineBatch => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  batchcode: r.batchcode ?? r.btc ?? r.shortcode ?? '',
  batchname: r.batchname ?? r.btn ?? r.recname ?? '',
  fiscalyear: r.fiscalyear ?? r.fyr ?? '',
  scenariocode: r.scenariocode ?? r.scc ?? '',
  statecode: r.statecode ?? r.stc ?? '',
  statename: r.statename ?? r.stn ?? '',
  readiness: Number(r.readiness ?? r.rdn ?? 0),
  forecaststart: r.forecaststart ?? r.fst ?? '',
  created: r.created ?? r.crt ?? '',
});

export const fetchBaselineCoverage = async (fiscalyear: string, scenariocode: string) =>
  rows(await postBiz({s: 'bieforecastbaseline', a: 'coverage', fyr: fiscalyear, scc: scenariocode })).map(normalizeCoverageRow);

export const fetchForecastVariables = async (fiscalyear: string) =>
  rows(await postBiz({s: 'bieforecastbaseline', a: 'variables', fyr: fiscalyear })).map(normalizeVariableRow);

export const createForecastBatch = async (fiscalyear: string, scenariocode: string, batchname: string) =>
  normalizeBatch(json(await postBiz({s: 'bieforecastbaseline', a: 'createbatch', fyr: fiscalyear, scc: scenariocode, nam: batchname })));

export const runMissingPeriodForecast = async (batchid: number, options: any) =>
  json(await postBiz({s: 'bieforecastbaseline', a: 'runforecast', rid: batchid, opt: options || {} }));

export const fetchForecastQuality = async (batchid: number) =>
  json(await postBiz({s: 'bieforecastbaseline', a: 'quality', rid: batchid }));

export const fetchForecastRows = async (batchid: number) =>
  rows(await postBiz({s: 'bieforecastbaseline', a: 'forecastrows', rid: batchid }));

export const publishForecastBaseline = async (batchid: number, notes: string) =>
  json(await postBiz({s: 'bieforecastbaseline', a: 'publish', rid: batchid, nts: notes || '' }));
